// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"237a88ee","833":"26924452","839":"2d915373"}[chunkId] + ".chunk.js";
};